export default __webpack_public_path__ + "static/media/dispensary_mobile.f074af28.png";